export default __webpack_public_path__ + "52e8ecc2b605ada812cf3fd0a596a498.png";